module.exports = __webpack_public_path__ + "img/pro-zdTicon12.ce26b977.png";